import {cx} from "emotion";
import * as React from "react";

import "./types-grid.scss";

import {cs}       from "@Common/react/chain-services";
import {ItemGrid} from "@Common/ui-components/heavy/mailing-ui/create-mailing-list-modal/select-type/item-grid";
import {Badge}    from "@Common/ui-components/heavy/common/design2/badge/badge";

export const TypesGrid = ({types, onSelect}) => cs(
    ["isBannered", ({}, next) => next(types.some((type) => !!type.bannerMsg))],
    ["itemGrid", ({isBannered}, next) => ItemGrid({
        minWidth: isBannered ? 200 : 120,
        maxWidth: isBannered ? 225 : 170,
        minGap: 10,
        maxGap: 21,
        count: types.length,
        stretch: types.length !== 1,
        next,
    })],
    ({itemGrid}) => (
        <div className={cx("types-grid types-grid-4dd")} style={{textAlign: types.length === 1 ? "left" : "center"}} ref={itemGrid.containerRef}>
            {types.map((type, i) => (
                <div {...{
                    className: "type",
                    style: {
                        width: itemGrid.cellWidth ?? 133,
                        marginRight: (
                            (i + 1) % itemGrid.colCount !== 0 &&
                            i !== types.length - 1
                        ) && (itemGrid.gapSize ?? 16) || undefined,
                    },
                    key: i,
                    onClick: () => {
                        if(hj && typeof hj === 'function')
                        {
                            hj('event', `${type?.value?.replace(' ', '_')?.replace('/', '_')}_click_event`);
                        }
                        onSelect(type.value)
                    },
                }}>
                    {!!type.bannerMsg && (
                        <div className="banner" xd-qa-type="label" xd-qa-name={"Address Lists Banner " + type.label}>
                            {type.bannerMsg}
                        </div>
                    )}
                    {!!type.badge && Badge({
                        color: "blue",
                        text: type.badge,
                    })}
                    <div className="icon" xd-qa-type="icon" xd-qa-name={"Address Lists "+type.label}>
                        <img src={type.icon}/>
                    </div>
                    <div className="text" xd-qa-type="label" xd-qa-name={"Address Lists "+type.label}>
                        <div className="middle-align">
                            {type.label}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    ),
);
